import { Component } from '@angular/core';
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: 'maplayout',
  templateUrl: 'mapLayout.template.html',
})
export class MapLayoutComponent {

  public isNavigationOpen = false;

  constructor(
    public app: ApplicationConfigService
  ) {
  }

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-small');
  }

  onResize() {
  }

  onNavigationToggle(bool: boolean): void {
    const body = document.getElementsByTagName('body')[0];
    if (bool) {
      body.classList.add('mini-navbar');
    } else {
      body.classList.remove('mini-navbar');
    }
  }
}
